export function formatPrice(price: number) {
  const rounded = Math.round(price * 100) / 100;
  const currencyFormatter = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return currencyFormatter.format(rounded);
}

export function getSavingPercentage(annualPrice: number, monthlyPrice: number) {
  if (annualPrice && monthlyPrice) {
    const monthlyAnnualCost = monthlyPrice * 12;
    const savingsPercentage =
      ((monthlyAnnualCost - annualPrice) / monthlyAnnualCost) * 100;

    return Math.round(savingsPercentage);
  }
}
